export const styleSheet = (props) => ({
  sideBarRoot: {
    screenY: "auto",
    height: "100vh",
  },
  sideBarListText: {
    fontSize: "12.5px  !important",
    textTransform: "uppercase",
  },
  navCollapseItems: {
    "& .MuiListItemIcon-root": {
      minWidth: "32px",
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      border: "none",
      backgroundColor: "rgba(0, 0, 0, 0.08)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0px",
      "& .MuiSvgIcon-root": {
        fontSize: "18px",
      },
      "& img": {
        width: "14px !important",
        marginLeft: props.pcOpen ? "1.5px !important" : "-1.5px !important",
        marginTop: "1px !important",
        height: "auto",
        display: "flex",
        alignSelf: "center",
        justifySelf: "center"
      }
    }
  },
  sideBarRootList: {
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(54, 131, 188, 0.6)",
    },
    "&::-webkit-scrollbar-track": {
      background: "#ccc",
    },
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "& .Mui-selected": {
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    },
    "& .MuiListItemIcon-root": {
      minWidth: "32px",
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      border: "none",
      backgroundColor: "rgba(0, 0, 0, 0.08)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "8px",
      padding: "0px",
      "& .MuiSvgIcon-root": {
        fontSize: "18px",
      },
      "& img": {
        width: "14px !important",
        marginLeft: props.pcOpen ? "2px !important" : "-1.5px !important",
        marginTop: "1px !important",
        height: "auto",
        display: "flex",
        alignSelf: "center",
        justifySelf: "center"
      }
    }
  },
});
